import React from 'react';
import { ReactComponent as OpenEye } from '../../assets/images/icons/openEye.svg';

export default function OpenEyeIcon(props) {
  return (
    <OpenEye className={`icon ${props.className}`} />
  );
}
